"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentCard = function (_a) {
    var _b, _c;
    var baseTournament = _a.baseTournament, topScores = _a.topScores, Banner = _a.Banner;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var onClickHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/tournaments/finished/".concat(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.slug)));
    }, [router, baseTournament, generateUrlWithLang]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) },
        react_1.default.createElement(Banner, { images: baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.images }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("img", { src: "/img/tournaments/laurelIconLeft.svg", alt: "laurel" }),
                react_1.default.createElement("h3", null, translateLocale(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.name)),
                react_1.default.createElement("img", { src: "/img/tournaments/laurelIconRight.svg", alt: "laurel" })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.winner },
                t('winner'),
                ":"),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.winner, " ").concat(styles_module_scss_1.default.bold) }, (_c = (_b = topScores === null || topScores === void 0 ? void 0 : topScores[0]) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.nickname),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.results, onClick: onClickHandler }, t('results')))));
};
exports.default = TournamentCard;
